export default {
  title: {
    en: 'Something went wrong',
  },
  text: {
    en: 'We`re having technical issues at that moment. Please try again later or contact our customer support at',
  },
  buttonTitle: {
    en: 'Ok',
  },
}
